import React, { Component } from "react";
import "../../styles/footer/FooterSVGShape.css";
import $ from "jquery";

export default class FooterSVGShape extends Component {
  componentDidMount() {
    this.el = $(".FooterSVGShape");
    this.pageWrapper = $(".page-wrapper");

    $(window).on("resize", this.setWidth.bind(this));
    setTimeout(
      function() {
        this.setWidth();
      }.bind(this),
      750
    );
  }
  setWidth() {
    this.el.css("width", this.pageWrapper.width() + 1);
  }
  render() {
    return (
      <svg
        className="FooterSVGShape"
        width="1880"
        height="595.99"
        viewBox="0 0 1880 595.99"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient
            id={`linear-gradient-footer-${this.props.page}`}
            x1="0.5"
            x2="0.5"
            y2="1"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#fa1d75" />
            <stop offset="1" stopColor="#662eff" />
          </linearGradient>
        </defs>

        <path
          transform="translate(0 33.99)"
          fill={`url(#linear-gradient-footer-${this.props.page})`}
        >
          <animate
            id="animate-to-check"
            repeatCount="indefinite"
            fill="freeze"
            attributeName="d"
            dur="35s"
            values="
              M0-1.1S203.891-75.1,662.969-1.1,1880-1.1,1880-1.1V562H0Z; 
              M0-1.1s704.125,121.4,1123.031,15.135S1880-1.1,1880-1.1V562H0Z;
              M0-1.1S203.891-75.1,662.969-1.1,1880-1.1,1880-1.1V562H0Z;"
          />
        </path>
      </svg>
    );
  }
}
